export default {
    props: {
        scrollableVirtual: {
            type: Boolean,
            kComposite: 'scrollable.virtual'
        }, 
        scrollableEndless: {
            type: Boolean,
            kComposite: 'scrollable.endless'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Scrollable.js